import {useEffect,useRef,useState} from 'react';
import {useCopy} from '@platform/ui/config';
import {antMediaEmbedUrl,validatePlaybackSource,type PlaybackSource,type PlaybackStatus} from './playback';

// Serkan, 2026-10-10: retain the server's official player and all native functions.
// No replacement video controls, SDK retry owner or DOM/CSS injection into the frame.
export function AntMediaPlayer({source,active=true,onStatus}:{source:Extract<PlaybackSource,{kind:'antmedia'}>;active?:boolean;onStatus?:(status:PlaybackStatus)=>void}){
 const t=useCopy(),callback=useRef(onStatus);callback.current=onStatus;
 const [status,setStatus]=useState<PlaybackStatus>('connecting'),[error,setError]=useState('');
 const identity=JSON.stringify(source);
 useEffect(()=>{
  const invalid=validatePlaybackSource(source);
  const update=(value:PlaybackStatus)=>{setStatus(value);callback.current?.(value);};
  setError(invalid?.code??'');
  if(!active){update('idle');return;}
  if(invalid){update(invalid.code==='expired'?'expired':'error');return;}
  update('connecting');
  const timeout=source.expiresAtUtc?window.setTimeout(()=>{setError('expired');update('expired');},Math.min(2147483647,Date.parse(source.expiresAtUtc)-Date.now())):undefined;
  return()=>clearTimeout(timeout);
 },[identity,active]);
 // Cross-origin load is NOT proof of video playback, authorization, or latency.
 // The server-owned player renders those states and controls inside its frame.
 const valid=active&&!validatePlaybackSource(source)&&status!=='expired';
 return <div className="broadcast-player antmedia-player" data-ui="broadcast-player" data-transport="antmedia" data-playback-status={active?status:'idle'}>
  {valid?<iframe key={identity} src={antMediaEmbedUrl(source)} title={t('broadcast.officialPlayer')} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen referrerPolicy="no-referrer" onLoad={()=>{setStatus('embedded');callback.current?.('embedded');}}/>:<div className="broadcast-player-message" role="status">{t(active&&error?'broadcast.error.'+error:'broadcast.status.idle')}</div>}
 </div>;
}
